<template>
  <div class="auth-wrapper auth-v2">
    <b-row
        class="auth-inner m-0"
        style="direction: ltr;"
    >

      <!-- Left Text-->
      <b-col
          lg="8"
          class="d-none d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
              fluid
              :src="imgUrl"
              alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-5 form-auth"
      >
        <!-- Brand logo-->
        <b-link class="brand-logo">

          <h2 class="brand-text text-primary ml-1" />
          <span class="brand-logo">
            <b-img
                :src="appLogoImage"
                alt="logo"
            />
          </span>
        </b-link>
        <!-- /Brand logo-->
        <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
        >
          <b-card-title
              title-tag="h2"
              class="font-weight-bold mb-1"
          >
            ثبت نام کاربر جدید
          </b-card-title>
          <b-card-text class="mb-2" />

          <!-- form -->
          <validation-observer
              ref="registerValidation"
              #default="{invalid}"
          >
            <b-form
                class="auth-register-form mt-2 "
                @submit.prevent
            >
              <!-- username -->
              <b-form-group
                  label="نام"
                  label-for="register-name"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Name"
                    vid="name"
                    rules="required"
                >
                  <b-form-input
                      id="register-name"
                      v-model="user.name"
                      name="register-name"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group
                  label="نام خانوادگی"
                  label-for="register-family"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Family"
                    vid="family"
                    rules="required"
                >
                  <b-form-input
                      id="register-family"
                      v-model="user.family"
                      name="register-family"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group
                  label-for="register-mobile"
                  label="شماره همراه"
              >
                <validation-provider
                    #default="{ errors }"
                    name="mobile"
                    vid="mobile"
                    rules="required"
                >
                  <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                        id="register-mobile"
                        v-model="user.mobile"
                        class="form-control-merge "
                        style="direction: ltr;"
                        :state="errors.length > 0 ? false:null"
                        name="register-mobile"
                        placeholder="09121234567"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox
                    id="register-privacy-policy"
                    v-model="status"
                    name="checkbox-1"
                >
                  <b-link style="color: #fff;font-weight: bold;">
                    قوانین و مقررات
                  </b-link> را می پذیرم.
                </b-form-checkbox>
              </b-form-group>

              <b-button
                  variant="light"
                  block
                  type="submit"
                  :disabled="invalid"
                  @click="registerForm"
              >
                ثبت نام
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <span>قبلا ثبت نام کرده اید؟</span>
            <b-link :to="{name:'login'}">
              <span style="font-weight: bolder;">&nbsp;وارد شوید</span>
            </b-link>
          </p>

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div>

          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
                variant="facebook"
                href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
                variant="twitter"
                href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button
                variant="google"
                href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
                variant="github"
                href="javascript:void(0)"
            >
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div>
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import Vue from 'vue'
import store from '@/store/index'
import User from '@/models/user'
import { func } from '@/func'

Vue.prototype.$func = func

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      user: new User('', '', '', ''),
      status: '',
      username: '',
      userEmail: '',
      password: '',
      sideImg: require('@/assets/images/pages/time_management.png'),
      // validation
      required,
      email,
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/time_management.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  mounted() {
    const { isRTL } = $themeConfig.layout
    const formGroup = document.getElementsByClassName('form-auth')
    formGroup[0].style.direction = isRTL ? 'rtl' : 'ltr'
  },
  methods: {
    registerForm() {
      if (this.$refs.registerValidation.validate()) {
        this.user.mobile = this.$func.fixNumbers(this.user.mobile)
        this.user.name = this.$func.fixNumbers(this.user.name)
        this.user.family = this.$func.fixNumbers(this.user.family)
        this.$store.dispatch('auth/register', { user: this.user }).then(() => {
          Vue.prototype.$mobileR = this.user.mobile
          this.$router.push({ path: 'register-verify' }).catch(() => {})
        }).catch(error => {
          this.loading = false
          console.log(error)
          this.message = (error.response && error.response.data)
              || error.message
              || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        })
      } else {
        this.showErr = true
      }
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '../../@core/scss/vue/pages/page-auth.scss';
.brand-logo img{
  width: 70px;
}
.auth-wrapper label,.auth-wrapper span,.auth-wrapper h2,.auth-wrapper .brand-text{
  color: #fff !important;
}
</style>
